import { Navigate, useLocation } from 'react-router-dom'

/**
 * `/know` y `/know/*` → `/data` y `/data/*`, conservando query string y hash.
 *
 * `/data` reemplazó a `/know` el 2026-09-09 (pedido de mg: "Know" pasa a
 * llamarse "Data" en toda la barra y en la URL). Este redirect queda de
 * forma indefinida — no es un shim temporal — porque hay mails de invitación
 * ya enviados y bookmarks de usuarios con `/know/{code}` en el historial que
 * siguen llegando después del rename. Montado en dos rutas (`/know` y
 * `/know/*`, ver `router.tsx`) para cubrir tanto la ruta pelada como
 * cualquier subruta (`/know/profile`, `/know/SMTQ`, …).
 */
export function RedirectKnowToData() {
  const location = useLocation()
  const rest = location.pathname.startsWith('/know')
    ? location.pathname.slice('/know'.length)
    : ''
  return <Navigate to={`/data${rest}${location.search}${location.hash}`} replace />
}
